import { useMemo, useState } from "react";
import { resourceCategories, resourceItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const categoryStyle: Record<string, string> = {
  漫画: "bg-primary-100 text-primary-800",
  小说: "bg-secondary-100 text-secondary-800",
  同人: "bg-accent-100 text-accent-900",
  本子: "bg-primary-100 text-primary-800",
  番外: "bg-secondary-100 text-secondary-800",
};

export default function ResourceHub() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    if (active === "全部") return resourceItems;
    return resourceItems.filter((item) => item.category === active);
  }, [active]);

  return (
    <section id="resources" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Resource Hub"
          title="资源入口：按内容形态归类"
          desc="这里把漫画、小说、同人、本子与番外等常见入口集中列出，并说明每类内容对应什么范围。切换分类即可查看该形态下的条目，无需跳转到其他页面。"
        />

        <div className="mt-8 p-1 rounded-full bg-background-50 border border-background-200 inline-flex flex-wrap gap-1">
          {resourceCategories.map((cat) => {
            const isActive = cat === active;
            return (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                aria-pressed={isActive}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((item) => (
            <article
              key={item.title}
              className="p-5 rounded-lg bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center justify-between gap-3">
                <span className={`px-2.5 py-1 rounded-full text-xs whitespace-nowrap ${categoryStyle[item.category] ?? "bg-background-200 text-foreground-700"}`}>
                  {item.kicker} · {item.category}
                </span>
                <i className="ri-bookmark-line text-primary-400" />
              </div>
              <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
              <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-refresh-line" />
                  {item.meta}
                </span>
                <div className="flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-xs px-2 py-0.5 rounded bg-background-200/70 text-foreground-700 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          * 以上条目为内容范围说明，页面本身不提供跳转，也不收集任何信息。
        </p>
      </div>
    </section>
  );
}